export default __webpack_public_path__ + "static/media/enjovom_bejelentkezés_csoportkép.3a4af23d.jpg";